import axios from "axios";
import React, { useState } from "react";
import { backendBookartUrl } from "../library/constants";
import Popup from '../components/Popup';
import { Modal, Button } from 'react-bootstrap';


const EditProduct = (props) => {

  const {
    isbn,
  } = props.data;


  const [data, setData] = useState(props.data);
  const [uneditable, setUneditable] = useState(true);
  const [result, setResult] = useState(false);
  const [show, setShow] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState('');
  const [popupMessage, setPopupMessage] = useState('');

  const disableSubmit = (event) => {
    event.preventDefault();
  };

  const deleteData = () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    var data = JSON.stringify({ isbn });
    var config = {
      method: "post",
      url: `${backendBookartUrl}/delete_product`,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        if (response.data.status === "success") {
          setResult(true);
          handleShowPopup('Delete Product', "Product Deleted Successfully");
        }
        else {
          setResult(true);
          handleShowPopup('Delete Product', response.data.message);
        }
      })
      .catch((err) => {
        setResult(true);
        handleShowPopup('Delete Product', err.response.data.message);
        console.log(err);
      });
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleEdit = () => {
    setUneditable(false);
  };

  const handleUpdate = (event) => {
    event.preventDefault()
    let sendingData = { ...data };
    const token = window.sessionStorage.getItem("JWTtoken");
    var requestData = JSON.stringify(sendingData);
    var config = {
      method: "post",
      url: `${backendBookartUrl}/product_update?=`,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: requestData,
    };
    axios(config)
      .then((response) => {
        setResult(true);
        setUneditable(true);
        handleShowPopup('Update Product', response.data.message);
      })
      .catch((error) => {
        setResult(true);
        handleShowPopup('Update Product', "Failed to Update product details. Retry Again!!!");
        console.log(error);
      });
  };

  const handleShowPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };


  return (
    <>
      <div className="container min-height60">
        {result ? (
          <Popup
            title={popupTitle}
            message={popupMessage}
            show={showPopup}
            handleClose={handleClosePopup}
          />
        ) : (
          <>
            <form onSubmit={disableSubmit}>
              <div className="row">
                <div className="col-12 margin-top-30">
                  <p><label>ISBN</label></p>
                  <p>
                    <input
                      type="number"
                      className="es-input"
                      placeholder="ISBN"
                      name="isbn"
                      value={data.isbn}
                      readOnly={true}
                      disabled={true}
                    />
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-6 margin-top-30">
                  <p><label>Title</label></p>
                  <p>
                    <input
                      type="text"
                      className="es-input"
                      placeholder="Title"
                      value={data.title}
                      readOnly={uneditable}
                      onChange={(e) => setData({ ...data, title: e.target.value })}
                      required={true}
                    />
                  </p>
                </div>
                <div className="col-6 margin-top-30">
                  <p><label>Author</label></p>
                  <p>
                    <input
                      type="text"
                      className="es-input"
                      placeholder="Author"
                      value={data.author}
                      readOnly={uneditable}
                      onChange={(e) => setData({ ...data, author: e.target.value })}
                      required={true}
                    />
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-6 margin-top-30">
                  <p><label>Year of Publication</label></p>
                  <p>
                    <input
                      type="number"
                      className="es-input"
                      placeholder="Year"
                      value={data.year}
                      readOnly={uneditable}
                      onChange={(e) => setData({ ...data, year: e.target.value })}
                      required={true}
                    />
                  </p>
                </div>
                <div className="col-6 margin-top-30">
                  <p><label>Stream</label></p>
                  <p>
                    <input
                      type="text"
                      className="es-input"
                      placeholder="Stream"
                      value={data.stream}
                      readOnly={uneditable}
                      onChange={(e) => setData({ ...data, stream: e.target.value })}
                      required={true}
                    />
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-6 margin-top-30">
                  <p><label>Currency</label></p>
                  <p>
                    <input
                      type="text"
                      className="es-input"
                      placeholder="Currency"
                      value={data.currency}
                      readOnly={uneditable}
                      onChange={(e) => setData({ ...data, currency: e.target.value })}
                      required={true}
                    />
                  </p>
                </div>
                <div className="col-6 margin-top-30">
                  <p><label>List Price</label></p>
                  <p>
                    <input
                      type="number"
                      className="es-input"
                      placeholder="Price"
                      value={data.list_price}
                      readOnly={uneditable}
                      onChange={(e) => setData({ ...data, list_price: e.target.value })}
                      required={true}
                    />
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-6 margin-top-30">
                  <p><label>Discount Category</label></p>
                  <p>
                    <input
                      type="text"
                      className="es-input"
                      placeholder="Discount"
                      value={data.discount_category}
                      readOnly={uneditable}
                      onChange={(e) => setData({ ...data, discount_category: e.target.value })}
                      required={true}
                    />
                  </p>
                </div>
                <div className="col-6 margin-top-30">
                  <p><label>Box Size</label></p>
                  <p>
                    <input
                      type="text"
                      className="es-input"
                      placeholder="Box"
                      value={data.box_size}
                      readOnly={uneditable}
                      onChange={(e) => setData({ ...data, box_size: e.target.value })}
                    />
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-6 margin-top-30">
                  <p><label>Publication Details</label></p>
                  <p>
                    <input
                      type="text"
                      className="es-input"
                      placeholder="Publication Details"
                      value={data.publication_details}
                      readOnly={uneditable}
                      onChange={(e) => setData({ ...data, publication_details: e.target.value })}
                      required={true}
                    />
                  </p>
                </div>
                <div className="col-6 margin-top-30">
                  <p><label>Top Seller</label></p>
                  <p>
                    <input
                      type="text"
                      className="es-input"
                      placeholder="Top Seller"
                      value={data.top_seller}
                      readOnly={uneditable}
                      onChange={(e) => setData({ ...data, top_seller: e.target.value })}
                      required={true}
                    />
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-6 margin-top-30">
                  <p><label>Latest Edition</label></p>
                  <p>
                    <input
                      type="text"
                      className="es-input"
                      placeholder="Latest Edition"
                      value={data.latest_edition}
                      readOnly={uneditable}
                      onChange={(e) => setData({ ...data, latest_edition: e.target.value })}
                      required={true}
                    />
                  </p>
                </div>
              </div>

              <div className="flex-space-between margin-top-30">
                {uneditable ? (
                  <button onClick={handleEdit} className="es-button primary">
                    Edit
                  </button>
                ) : (
                  <button onClick={handleUpdate} className="es-button primary">
                    Update
                  </button>
                )}
                <button className="es-button danger" onClick={handleShow}>
                  Delete
                </button>

                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>Delete Product</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>Confirm, to delete Product</Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                      Close
                    </Button>
                    <Button variant="danger" onClick={deleteData}>
                      Delete Product
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </form>
          </>
        )}
      </div>
    </>
  );
}

export default EditProduct;
